import { render, staticRenderFns } from "./BiQrCodeCreate.vue?vue&type=template&id=ccf58cb0&scoped=true&"
import script from "./BiQrCodeCreate.vue?vue&type=script&lang=js&"
export * from "./BiQrCodeCreate.vue?vue&type=script&lang=js&"
import style0 from "./BiQrCodeCreate.vue?vue&type=style&index=0&id=ccf58cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf58cb0",
  null
  
)

export default component.exports